// extracted by mini-css-extract-plugin
module.exports = {"w1k185gh":"w1k185gh","b1p4wizm":"b1p4wizm","b19djb3s":"b19djb3s","bc7tay0":"bc7tay0","twinkle-bc7tay0":"twinkle-bc7tay0","fadeFromTransparent":"fadeFromTransparent"};